import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "How does the remote process work?",
    a: "Everything happens online — there's nothing to download and nowhere to drive. As soon as you submit the form, you get a private, secure upload link for your photos (we email it to you too). We consult with you by email or phone about music and style, craft your film, and deliver it digitally. Families from coast to coast (and beyond) use our service every week.",
  },
  {
    q: "What photos do you need?",
    a: "Up to 60 of your favorites, from any era of their life. Phone snapshots, scanned prints, even slightly faded or damaged photos — all are welcome. Our editors gently restore, color-balance, and prepare every image by hand so each one looks its best on screen.",
  },
  {
    q: "Can you use our song?",
    a: "In most cases, yes. Tell us the song that meant the most to them — a hymn, a favorite artist, the song from their wedding — and we'll do everything we can to include it. If licensing makes that difficult, we'll help you choose a beautiful licensed alternative with the same feeling.",
  },
  {
    q: "How long is the video?",
    a: "Most tributes run 4–8 minutes, depending on your photo count and music choice. We pace every film to breathe — never rushed, never dragging — so family and friends can truly sit with each memory.",
  },
  {
    q: "How do we receive it?",
    a: "You'll receive a private HD download link you can watch and share anywhere. If you'd like something to hold onto, we also offer a USB keepsake version, beautifully packaged and mailed to you.",
  },
  {
    q: "Can it play at a funeral service?",
    a: "Absolutely — that's what most families use it for. We deliver universal file formats that play on any venue system, and if your funeral home or place of worship has specific requirements, just tell us and we'll prepare the film to match. Rush delivery is available when the service date is near.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="overline mb-4">Questions</div>
          <h2 className="serif text-4xl sm:text-5xl lg:text-[56px] font-light leading-[1.05] text-[#F5F0E8]">
            Gently
            <span className="italic text-[#E6B89C]"> answered.</span>
          </h2>
        </div>

        <div className="divide-y divide-[rgba(197,165,90,0.15)] border-y border-[rgba(197,165,90,0.15)]">
          {FAQS.map((f, i) => (
            <details
              key={i}
              data-testid={`faq-item-${i}`}
              className="group py-6"
            >
              <summary className="flex items-start justify-between gap-6 text-left">
                <span className="serif text-[20px] sm:text-[22px] text-[#F5F0E8] font-normal">{f.q}</span>
                <span className="shrink-0 inline-flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(212,175,55,0.3)] bg-[rgba(20,19,17,0.5)] transition-transform duration-500 group-open:rotate-45">
                  <Plus size={16} className="text-[#D4AF37]" strokeWidth={1.6} />
                </span>
              </summary>
              <div className="mt-4 text-[15.5px] text-[#A0988E] spectral leading-relaxed max-w-3xl">
                {f.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
